import { DialogProps, Dialog, Grid } from '@material-ui/core';
import { Text, PrimaryButton, IfRender } from 'library';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { tada } from 'react-animations';
import { Provider } from 'models';
import { useWidth } from 'reusableComponents/useWidth';
import CloseButton from 'reusableComponents/CloseButton';
const PROFILE = require('../../../../assets/images/default-sitter.png');

const animations = StyleSheet.create({
    tada: {
        animationName: tada,
        animationDuration: '1s',
    },
});

interface IProps extends DialogProps {
    provider: Provider;
}
export default function PublIcMessagingSuccessDialog({ open, onClose, provider }: IProps) {
    const _onClose = onClose as () => void;
    const breakpoint = useWidth();
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" onBackdropClick={_onClose} fullScreen={breakpoint === 'xs'}>
            <Grid
                container
                justify="center"
                alignItems="center"
                direction="column"
                style={{ width: 500, padding: 30, alignSelf: 'center' }}
                spacing={3}
            >
                <IfRender condition={breakpoint === 'xs'}>
                    <CloseButton onClose={_onClose} />
                </IfRender>
                <Grid item>
                    <Text variant="h1"> Your message to {provider.user.first_name} was sent!</Text>
                </Grid>
                <Grid item className={css(animations.tada)}>
                    <img
                        alt="profile avatar"
                        style={{ height: 200, width: 215, borderRadius: 25 }}
                        src={provider?.profile_image?.image ? provider.profile_image.image : PROFILE}
                    />
                </Grid>
                <Grid item>
                    <Text variant="h2">When they reply, you will get a text message.</Text>
                </Grid>

                <Grid item style={{ textAlign: 'center' }}>
                    <Text variant="body1">
                        In the meantime, explore the platform's other providers, create a job, or checkout our newsfeed.
                    </Text>
                </Grid>

                <Grid item>
                    <PrimaryButton onClick={onClose as () => void}>Continue to dashboard</PrimaryButton>
                </Grid>
            </Grid>
        </Dialog>
    );
}
